import debounceMixin from '@witkac/bootstrap4-components/src/mixins/debounceMixin';
import { mapState } from 'vuex';

import { serverError } from '@/utils/serverError';

import { notificationsMixin } from './notifications';

/**
 * Mixin do pobierania informacji o dokumencie z MDOK
 */
export const mdokDocumentMixin = {
  mixins: [debounceMixin, notificationsMixin],
  computed: mapState({ documentName: state => state.mdok.name, caseName: state => state.mdok.caseName }),
  methods: {
    // @vuese
    // Pobiera nazwę dokumentu
    loadDocumentName(uid, actionName = 'mdok/getDocumentName', mutationName = 'mdok/saveDocumentName') {
      if (!uid) {
        this.debounce(() => undefined);
        this.$store.commit(mutationName, null);
        this.afterNameGet && this.afterNameGet(null);
        return;
      }

      this.debounce(() => {
        const documentId =
          parseInt(this.$route.params.documentId) ||
          this.document?.id ||
          this.document?.documentId ||
          this.schema?._internal?.options?.external?.documentIndex?.documentId ||
          undefined;
        this.$store
          .dispatch(actionName, { uid: parseInt(uid), documentId })
          .then(data => this.afterNameGet && this.afterNameGet(data))
          .catch(err => this.notifyError(serverError(err.message || err)));
      }, 500)();
    }
  }
};
